import { useTranslation } from 'next-i18next'
// Dependencies.
import moment from 'moment-timezone'
import styled from 'styled-components'
import NumberFormat, { NumberFormatValues } from 'react-number-format'

import { EventHookInterface } from '../../../types'
import { fontWeights, colors } from '../../../utils'
import { H4 } from '../../H4'

const Div = styled.div`
  display: flex;
  color: ${colors.purple};

  & span {
    font-weight: ${fontWeights.semiBold};
    font-size: 20px;
    line-height: 130%;
    margin-right: 5px;
  }
`

// Props.
interface Props {
  eventHook: EventHookInterface
}

// Ticket Price.
export const TicketPrice: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Props.
  const { eventHook } = props
  const { price, currency, event_paid_type } = eventHook.value

  if (event_paid_type === 0) return null

  // ..
  return (
    <Div>
      <NumberFormat
        value={price}
        displayType="text"
        thousandSeparator={true}
        prefix={t(currency)}
        decimalScale={2}
        fixedDecimalScale={true}
      />
      <H4> {t(currency.toUpperCase())}</H4>
    </Div>
  )
}
